import { FallBackImage } from "../default/fallback-image";
import ReactPaginate from 'react-paginate';
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { fetchGetAdsFilters } from "../../../services/api";
import { NumericFormat } from 'react-number-format';
import { Container, Row, Col, Accordion, Modal, Button } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";

export default function StockInventoryListing({
    ads,
    pageSize,
    models
}) {
    const router = useRouter();
    const pageCount = Math.ceil(ads.paginationOut.totalRows / pageSize);
    const [showFilterModal, setShowFilterModal] = useState({ isOpen: false });
    const [showMore, setShowMore] = useState({ brands: false, models: false, yearsModel: false, transmissions: false, fuels: false });
    const [filters, setFilters] = useState({ isLoading: true, brands: [], models: [], yearsModel: [], transmissions: [], fuels: [] });

    const handlePageClick = (event) => {
        $(".ring-preloader").fadeIn();
        router.query.pag = event.selected;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    };
    const handleFilterCheckboxClick = (event, value, type) => {
        delete router.query['filter'];
        if (event.target.checked) {
            if (router.query[type]) router.query[type] = router.query[type] + `|${value}`;
            else router.query[type] = value;
        }
        else {
            if (router.query[type].indexOf('|') >= 0) {
                const splitStr = router.query[type].split('|');
                router.query[type] = splitStr.filter(item => item !== value).join('|');
            }
            else delete router.query[type];
        }
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleOrderChange = (event) => {
        $(".ring-preloader").fadeIn();
        router.query.ordem = event.target.value;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleGridTypeClick = () => {
        $(".ring-preloader").fadeIn();
        router.query.tipo_lista = 'grid';
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handleListTypeClick = () => {
        $(".ring-preloader").fadeIn();
        router.query.tipo_lista = 'list';
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handlePriceFromChange = (event) => {
        delete router.query['filter'];
        if (event.target.value) router.query.preco_de = event.target.value;
        else delete router.query['preco_de'];
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const handlePriceToChange = (event) => {
        delete router.query['filter'];
        if (event.target.value) router.query.preco_ate = event.target.value;
        else delete router.query['preco_ate'];
        delete router.query.pag;
        router.push(`${router.pathname}?${new URLSearchParams(router.query)}`);
    }
    const FilterComponent = ({ isFromMobile }) => {
        return (
            <div className={!isFromMobile ? "sidebar-widget bg-white rounded" : ''}>
                <div className="iv_listing">
                    <div className="iv_listing_top rounded">
                        <div className="iv_listing_filter_menu">
                            <div>
                                <span><i className="fa-solid fa-filter"></i>&nbsp;&nbsp;&nbsp;FILTRE SUA BUSCA</span>
                            </div>
                        </div>
                    </div>
                </div>

                <hr className="spacer mb-3" />
                <>
                    <div className="ml-20">
                        <div style={{ fontWeight: 'bolder' }}>PREÇO</div>
                        <div className="ml-10 mr-30 mt-2">
                            <p>
                                <select className="form-select" onChange={handlePriceFromChange}>
                                    <option value=''>Preço De:</option>
                                    <option value='10000'>R$ 10.000,00</option>
                                    <option value='20000'>R$ 20.000,00</option>
                                    <option value='30000'>R$ 30.000,00</option>
                                    <option value='40000'>R$ 40.000,00</option>
                                    <option value='50000'>R$ 50.000,00</option>
                                    <option value='60000'>R$ 60.000,00</option>
                                    <option value='70000'>R$ 70.000,00</option>
                                    <option value='80000'>R$ 80.000,00</option>
                                    <option value='90000'>R$90.000,00</option>
                                    <option value='100000'>R$ 100.000,00</option>
                                    <option value='200000'>R$ 200.000,00</option>
                                    <option value='300000'>R$ 300.000,00</option>
                                    <option value='400000'>R$ 400.000,00</option>
                                    <option value='500000'>R$ 500.000,00</option>
                                </select>
                            </p>
                            <p>
                                <select className="form-select" onChange={handlePriceToChange}>
                                    <option value=''>Preço Até:</option>
                                    <option value='10000'>R$ 10.000,00</option>
                                    <option value='20000'>R$ 20.000,00</option>
                                    <option value='30000'>R$ 30.000,00</option>
                                    <option value='40000'>R$ 40.000,00</option>
                                    <option value='50000'>R$ 50.000,00</option>
                                    <option value='60000'>R$ 60.000,00</option>
                                    <option value='70000'>R$ 70.000,00</option>
                                    <option value='80000'>R$ 80.000,00</option>
                                    <option value='90000'>R$90.000,00</option>
                                    <option value='100000'>R$ 100.000,00</option>
                                    <option value='200000'>R$ 200.000,00</option>
                                    <option value='300000'>R$ 300.000,00</option>
                                    <option value='400000'>R$ 400.000,00</option>
                                    <option value='500000'>R$ 500.000,00</option>
                                </select>
                            </p>
                        </div>
                    </div>
                    <hr className="spacer mt-3 mb-3" />
                </>
                {
                    filters.brands.length > 0
                        ? <>
                            <div className="ml-20" style={filters.brands.length > 7 && !showMore.brands ? { height: '200px', overflow: 'hidden' } : {}}>
                                <div style={{ fontWeight: 'bolder' }}>MARCA</div>
                                {
                                    filters.brands.map((item, index) =>
                                        <div className="ml-10 mr-10" key={index}>
                                            <label className="label-form">
                                                <input style={{ marginRight: "10px" }}
                                                    className="chck-form"
                                                    type="checkbox"
                                                    defaultChecked={router.query.marca ? router.query.marca.split('|').includes(item.name) : false}
                                                    onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'marca'); }} />
                                                {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                            </label>
                                        </div>)
                                }
                            </div>
                            {
                                filters.brands.length > 7
                                    ? !showMore.brands
                                        ? <div className="a-style1 ml-20" href="#" onClick={() => { setShowMore({ ...showMore, brands: true }); }}>ver mais...</div>
                                        : <div className="a-style1 ml-20" href="#" onClick={() => { setShowMore({ ...showMore, brands: false }); }}>ver menos...</div>
                                    : null
                            }
                            <hr className="spacer mt-3 mb-3" />
                        </>
                        : null
                }
                {
                    models.models.length > 0
                        ? <>
                            <div className="ml-20" style={filters.models.length > 7 && !showMore.models ? { height: '200px', overflow: 'hidden' } : {}}>
                                <div style={{ fontWeight: 'bolder' }}>MODELO</div>
                                {
                                    filters.models.map((item, index) =>
                                        <div className="ml-10 mr-10" key={index}>
                                            <label className="label-form">
                                                <input style={{ marginRight: "10px" }}
                                                    type="checkbox"
                                                    defaultChecked={router.query.modelo ? router.query.modelo.split('|').includes(item.name) : false}
                                                    onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'modelo'); }} />
                                                {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                            </label>
                                        </div>)
                                }
                            </div>
                            {
                                filters.models.length > 7
                                    ? !showMore.models
                                        ? <div className="a-style1 ml-20" href="#" onClick={() => { setShowMore({ ...showMore, models: true }); }}>ver mais...</div>
                                        : <div className="a-style1 ml-20" href="#" onClick={() => { setShowMore({ ...showMore, models: false }); }}>ver menos...</div>
                                    : null
                            }
                            <hr className="spacer mt-3 mb-3" />
                        </>
                        : null
                }
                {
                    filters.yearsModel.length > 0
                        ? <>
                            <div className="ml-20" style={filters.yearsModel.length > 7 && !showMore.yearsModel ? { height: '200px', overflow: 'hidden' } : {}}>
                                <div style={{ fontWeight: 'bolder' }}>ANO MODELO</div>
                                {
                                    filters.yearsModel.map((item, index) =>
                                        <div className="ml-10 mr-10" key={index}>
                                            <label className="label-form">
                                                <input
                                                    style={{ marginRight: "10px" }}
                                                    type="checkbox"
                                                    defaultChecked={router.query.ano ? router.query.ano.split('|').includes(item.name) : false}
                                                    onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'ano'); }} />
                                                {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                            </label>
                                        </div>)
                                }
                            </div>
                            {
                                filters.yearsModel.length > 7
                                    ? !showMore.yearsModel
                                        ? <div className="a-style1 ml-20" href="#" onClick={() => { setShowMore({ ...showMore, yearsModel: true }); }}>ver mais...</div>
                                        : <div className="a-style1 ml-20" href="#" onClick={() => { setShowMore({ ...showMore, yearsModel: false }); }}>ver menos...</div>
                                    : null
                            }
                            <hr className="spacer mt-3 mb-3" />
                        </>
                        : null
                }
                {
                    filters.transmissions.length > 0
                        ? <>
                            <div className="ml-20">
                                <div style={{ fontWeight: 'bolder' }}>CÂMBIO</div>
                                {
                                    filters.transmissions.map((item, index) =>
                                        <div className="ml-10 mr-10" key={index}>
                                            <label className="label-form">
                                                <input
                                                    style={{ marginRight: "10px" }}
                                                    type="checkbox"
                                                    defaultChecked={router.query.cambio ? router.query.cambio.split('|').includes(item.name) : false}
                                                    onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'cambio'); }} />
                                                {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                            </label>
                                        </div>)
                                }
                            </div>
                            <hr className="spacer mt-3 mb-3" />
                        </>
                        : null
                }
                {
                    filters.fuels.length > 0
                        ? <>
                            <div className="ml-20">
                                <div style={{ fontWeight: 'bolder' }}>COMBUSTÍVEL</div>
                                {
                                    filters.fuels.map((item, index) =>
                                        <div className="ml-10 mr-10" key={index}>
                                            <label className="label-form">
                                                <input
                                                    style={{ marginRight: "10px" }}
                                                    type="checkbox"
                                                    defaultChecked={router.query.combustivel ? router.query.combustivel.split('|').includes(item.name) : false}
                                                    onClick={(e) => { handleFilterCheckboxClick(e, item.name, 'combustivel'); }} />
                                                {item.name}<sup style={{ marginLeft: '2px' }}>{`(${item.quantity})`}</sup>
                                            </label>
                                        </div>)
                                }
                            </div>
                            <div style={{ height: '20px' }}></div>
                        </>
                        : null
                }
            </div >
        )
    }

    useEffect(() => {
        if (filters.isLoading) {
            fetchGetAdsFilters({
                condition: router.pathname === '/novos'
                    ? 'NEW'
                    : router.pathname === '/seminovos'
                        ? 'USED'
                        : ''
            })
                .then(res => {
                    if (res) { setFilters({ isLoading: false, ...res }); }
                })
                .catch(() => { setFilters({ ...filters, isLoading: false }); });
        }
        else if (!filters.isLoading) $(".at_scrollbar").mCustomScrollbar({ axis: "y" });
    }, [filters, router.pathname]);

    useEffect(() => {
        $(".ring-preloader").fadeOut();
    }, [ads]);

    return (
        <section className="inventory-details-area ptb-40">
            <Container>
                <Row>
                    <Col xl={3} lg={4} md={3}>
                        <FilterComponent isFromMobile={false} />
                    </Col>
                    <Col xl={9} lg={8} md={12}>
                        <div className="iv_listing mt-xl-0">
                            <div className="iv_listing_top d-flex flex-wrap align-items-center bg-white justify-content-end rounded mb-2">
                                <div className="iv_listing_filter_menu d-flex flex-wrap align-items-center justify-content-center">
                                    <select
                                        className="form-select fw-500"
                                        onChange={handleOrderChange}>
                                        <option value='BRAND_AND_MODEL'>Marca e Modelo</option>
                                        <option value='LOWEST_PRICE'>Menor Preço</option>
                                        <option value='BIGGEST_PRICE'>Maior Preço</option>
                                        <option value='NEWER_VEHICLES'>Mais Novos</option>
                                    </select>
                                    <a href="#" className={`grid_btn ${!router.query.tipo_lista || router.query.tipo_lista === 'grid' ? 'active' : ''}`} onClick={handleGridTypeClick}><i className="flaticon-menu-1"></i></a>
                                    <a href="#" className={`grid_btn ${router.query.tipo_lista && router.query.tipo_lista === 'list' ? 'active' : ''}`} onClick={handleListTypeClick}><i className="flaticon-list-interface-symbol"></i></a>
                                    <a href="#" className={`grid_btn2`} onClick={() => { setShowFilterModal({ ...showFilterModal, isOpen: true }); }}><i className="fa-solid fa-magnifying-glass"></i></a>
                                </div>
                            </div>
                            <div>
                                <p className="mb-0 fw-500 d-inline-block" style={{ fontSize: '14px' }}>{`${ads.paginationOut.totalRows} ofertas encontradas`}</p>
                            </div>
                            <div className="row g-4 justify-content-center">
                                {
                                    ads.items.length > 0
                                        ? ads.items.map((item, index) =>
                                            !router.query.tipo_lista || router.query.tipo_lista === 'grid'
                                                ? <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6" key={index}>
                                                    <div
                                                        className="filter-card-item position-relative overflow-hidden rounded bg-white"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => { window.location = `anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}` }}
                                                    >
                                                        <div
                                                            className="feature-thumb position-relative overflow-hidden"
                                                            style={{
                                                                position: 'relative',
                                                                width: '100%',
                                                                maxWidth: '430px',
                                                                aspectRatio: '70/45'
                                                            }}>
                                                            <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}>
                                                                <FallBackImage
                                                                    className='img-card-fluid'
                                                                    priority={true}
                                                                    alt={`${item.brand} ${item.model}`}
                                                                    src={item.mainPhoto ? item.mainPhoto : "/img/no-image.jpeg"} />
                                                            </a>
                                                        </div>
                                                        <div className="filter-card-content">
                                                            <div className="price-btn text-end position-relative">
                                                                {
                                                                    item.promotionalPrice
                                                                        ? <h5 className="price">
                                                                            {
                                                                                item.price ?
                                                                                    <NumericFormat
                                                                                        className="small-btn-meta"
                                                                                        style={{ color: 'white', fontSize: '14px', textDecoration: 'line-through' }}
                                                                                        value={item.price ?? 0}
                                                                                        displayType={'text'}
                                                                                        thousandSeparator="."
                                                                                        decimalSeparator=","
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        prefix='De R$ ' />
                                                                                    : <span className="small-btn-meta">Consulte-nos</span>
                                                                            }
                                                                        </h5>
                                                                        : null
                                                                }
                                                                <h5 className="price">
                                                                    {
                                                                        item.price ?
                                                                            <NumericFormat
                                                                                className="small-btn-meta"
                                                                                style={{ fontSize: '16px' }}
                                                                                value={item.promotionalPrice ? item.promotionalPrice : item.price}
                                                                                displayType={'text'}
                                                                                thousandSeparator="."
                                                                                decimalSeparator=","
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={true}
                                                                                prefix={`${item.promotionalPrice ? 'Por R$ ' : 'R$ '}`} />
                                                                            : <span className="small-btn-meta">Consulte-nos</span>
                                                                    }
                                                                </h5>
                                                            </div>
                                                            <a
                                                                href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}
                                                                className="mt-2 d-block">
                                                                <span className="h5">{`${item.brand} ${item.model}`}</span>
                                                            </a>
                                                            <span
                                                                className="meta-content"
                                                                style={{
                                                                    textOverflow: 'ellipsis',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    display: 'inline-block',
                                                                    width: '100%'
                                                                }}>{item.version}</span>
                                                            <hr className="spacer mt-3 mb-3" />
                                                            <div className="card-feature-box d-flex align-items-center">
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.transmission}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="flaticon-steering-wheel"></i></span>
                                                                    {item.transmission}
                                                                </div>
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.fuel}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="flaticon-petrol"></i></span>
                                                                    {item.fuel}
                                                                </div>
                                                            </div>
                                                            <div className="card-feature-box d-flex align-items-center">
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.transmission}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="flaticon-calendar"></i></span>
                                                                    {item.yearModel}
                                                                </div>
                                                                <div
                                                                    className="icon-box d-flex align-items-center"
                                                                    title={item.fuel}
                                                                    style={{
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        display: 'inline-block',
                                                                        width: '100%'
                                                                    }}>
                                                                    <span className="me-2"><i className="fa fa-gauge"></i></span>
                                                                    <NumericFormat
                                                                        value={item.mileage ?? 0}
                                                                        displayType={'text'}
                                                                        thousandSeparator={'.'}
                                                                        decimalSeparator={','}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}>
                                                                <div className="p-2 d-flex align-items-center justify-content-center">
                                                                    <button className="btn btn-md btn-primary-vehicle">
                                                                        Ver Detalhes
                                                                        <i className="fa fa-angle-right"></i>
                                                                    </button>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                : <div className="col-12" key={index}>
                                                    <div
                                                        className="listing_card_item bg-white rounded overflow-hidden d-flex flex-row align-items-center position-relative"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => { window.location = `anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}` }}>
                                                        <div className="thumb-wrapper rounded-start">
                                                            <div
                                                                className="feature-thumb position-relative overflow-hidden"
                                                                style={{
                                                                    position: 'relative',
                                                                    width: '200px',
                                                                    height: '200px',
                                                                    aspectRatio: '1/1'
                                                                }}>
                                                                <FallBackImage
                                                                    className='img-card-fluid'
                                                                    alt={`${item.brand} ${item.model}`}
                                                                    sizes="30vw"
                                                                    loading="lazy"
                                                                    src={item.mainPhoto ? item.mainPhoto : "/img/no-image.jpeg"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="d-flex flex-column justify-content-between" style={{ height: '200px', width: '100%' }}>
                                                            <div className="ml-20 mt-2">
                                                                <div className="d-flex flex-row justify-content-between">
                                                                    <div>
                                                                        <h5 className="mb-0">{`${item.brand} ${item.model}`}</h5>
                                                                        <span className="meta-text" style={{ fontSize: '14px' }}><strong className="fw-semibold">{item.version}</strong></span>
                                                                        <div className="card-feature-box d-flex flex-wrap align-items-center mt-20">
                                                                            <div
                                                                                className="icon-box d-flex align-items-center border"
                                                                                style={{ fontSize: '12px' }}
                                                                                title={item.transmission}>
                                                                                <span className="me-2"><i className="flaticon-steering-wheel"></i></span>
                                                                                {item.transmission}
                                                                            </div>
                                                                            <div
                                                                                className="icon-box d-flex align-items-center border"
                                                                                style={{ fontSize: '12px' }}
                                                                                title={item.fuel}>
                                                                                <span className="me-2"><i className="flaticon-petrol"></i></span>
                                                                                {item.fuel}
                                                                            </div>
                                                                            <div
                                                                                className="icon-box d-flex align-items-center border"
                                                                                style={{ fontSize: '12px' }}
                                                                                title={item.yearModel}>
                                                                                <span className="me-2"><i className="flaticon-calendar"></i></span>
                                                                                {item.yearModel}
                                                                            </div>
                                                                            <div
                                                                                className="icon-box d-flex align-items-center border"
                                                                                style={{ fontSize: '12px' }}
                                                                                title={item.mileage}>
                                                                                <span className="me-2"><i className="fa fa-gauge"></i></span>
                                                                                <NumericFormat
                                                                                    value={item.mileage ?? 0}
                                                                                    displayType={'text'}
                                                                                    thousandSeparator={'.'}
                                                                                    decimalSeparator={','}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mr-20 d-flex flex-column align-items-end mt-1">
                                                                        {
                                                                            item.promotionalPrice
                                                                                ? <h5>
                                                                                    {
                                                                                        item.price ?
                                                                                            <NumericFormat
                                                                                                className="small-btn-meta"
                                                                                                style={{ color: 'white', fontSize: '12px', textDecoration: 'line-through' }}
                                                                                                value={item.price ?? 0}
                                                                                                displayType={'text'}
                                                                                                thousandSeparator="."
                                                                                                decimalSeparator=","
                                                                                                decimalScale={2}
                                                                                                fixedDecimalScale={true}
                                                                                                prefix='De R$ ' />
                                                                                            : <span className="small-btn-meta">Consulte-nos</span>
                                                                                    }
                                                                                </h5>
                                                                                : null
                                                                        }
                                                                        <h5>
                                                                            {
                                                                                item.price ?
                                                                                    <NumericFormat
                                                                                        className="small-btn-meta"
                                                                                        style={{ fontSize: '12px' }}
                                                                                        value={item.promotionalPrice ? item.promotionalPrice : item.price}
                                                                                        displayType={'text'}
                                                                                        thousandSeparator="."
                                                                                        decimalSeparator=","
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale={true}
                                                                                        prefix={`${item.promotionalPrice ? 'Por R$ ' : 'R$ '}`} />
                                                                                    : <span className="small-btn-meta">Consulte-nos</span>
                                                                            }
                                                                        </h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        )
                                        : <div style={{ textAlign: 'center' }}>
                                            <p>nenhum registro encontrado...</p>
                                        </div>
                                }
                            </div>
                            <div className="template-pagination mt-5 pg-style-2">
                                <ReactPaginate
                                    forcePage={router.query.pag ? parseInt(router.query.pag) : 0}
                                    className="d-flex align-items-center justify-content-center"
                                    activeLinkClassName="active"
                                    breakLabel="..."
                                    nextLabel={<i className="fa-solid fa-angles-right"></i>}
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={pageCount}
                                    previousLabel={<i className="fa-solid fa-angles-left"></i>}
                                    renderOnZeroPageCount={null} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            {
                showFilterModal.isOpen
                    ? <Modal
                        show={showFilterModal.isOpen}
                        backdrop="static"
                        keyboard={false}
                        scrollable
                    >
                        <Modal.Body className="p-0">
                            <FilterComponent isFromMobile={true} />
                        </Modal.Body>
                        <Modal.Footer style={{ position: 'sticky', bottom: '0px', zIndex: '1055' }}>
                            <Button
                                variant="secondary"
                                style={{ color: 'white', width: '100%' }}
                                onClick={() => { setShowFilterModal({ ...showFilterModal, isOpen: false }); }}>Ver Resultado</Button>
                        </Modal.Footer>
                    </Modal>
                    : null
            }
        </section>
    );
}